// extracted by mini-css-extract-plugin
module.exports = {"block":"AuctionWaitingWidget_block__2mc7a","wrapper":"AuctionWaitingWidget_wrapper__2Ymq-","label":"AuctionWaitingWidget_label__1RJNj","icon":"AuctionWaitingWidget_icon__19Bqc"};